import type { QuoteItem_ } from 'src/api/db/apiQuoteItem'
import { ProductRow } from '../ProductRow'
import { CustomRow } from '../CustomRow'

export const QuoteItemRow = ({
  quote_item,
  isEditMode,
  showDiscountColumn = true,
  isReadOnly = false,
}: {
  quote_item: QuoteItem_
  isEditMode?: boolean
  showDiscountColumn?: boolean
  isReadOnly?: boolean
}) => {
  if (quote_item.type === 'product') {
    return (
      <ProductRow
        quote_item={quote_item}
        isEditMode={isEditMode}
        showDiscountColumn={showDiscountColumn}
        isReadOnly={isReadOnly}
      />
    )
  }

  return (
    <CustomRow
      quote_item={quote_item}
      isEditMode={isEditMode}
      showDiscountColumn={showDiscountColumn}
      isReadOnly={isReadOnly}
    />
  )
}
